import { onMounted, ref, computed, watch } from "vue";
import { useRoute } from "@nuxtjs/composition-api";
import { useUser } from "/composables/useUser";
import { useImageSources } from "/composables/useImageSources";
import { useDownloadables } from "/composables/useDownloadables";
import { useScrollTriggerAnimation } from "/composables/useScrollTriggerAnimation";
import {
  templateRef,
  onClickOutside,
  useElementSize,
  useClipboard,
} from "@vueuse/core";


export default {
  __name: 'index',
  props: {
  sku: {
    type: String,
    required: false,
  },
  name: {
    type: String,
    required: true,
  },
  serieType: {
    type: String,
    required: true,
  },
  serie: {
    type: String,
    required: false,
  },
  designer: {
    type: String,
    required: false,
  },
  finish: {
    type: String,
    required: false,
  },
  media: {
    type: Object,
    required: true,
  },
  collections: {
    type: Array,
    required: true,
  },
  info: {
    type: Array,
    required: false,
  },
  to: {
    type: String,
    required: false,
  },
  download: {
    type: String,
    required: false,
  },
  twoD: {
    type: Boolean,
    required: false,
  },
  threeD: {
    type: Boolean,
    required: false,
  },
  bundle: {
    type: Boolean,
    required: false,
  },
  private: {
    type: Boolean,
    required: false,
    default: false,
  },
  finishesTotal: {
    type: [Number, String],
    required: false,
  },
  capHeight: {
    type: Boolean,
    required: false,
    default: false,
  },
  useReveal: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {

const props = __props;



const route = useRoute();
const contextMenuData = ref();
const source = computed(() => {
  return process.client
    ? `${window.location.origin}/${route.value.params.locale}${props.to}`
    : "";
});

const { text, copy, copied, isSupported } = useClipboard({ source });
const { reveal } = useScrollTriggerAnimation();
const tpl_inner = templateRef("tpl_inner");
const tpl_btn = templateRef("tpl_btn");
const tpl_contextMenu = templateRef("tpl_contextMenu");
const showModal = ref(false);
const card_collections = computed(() => {
  return [...props.collections].join(", ");
});
const { logged } = useUser();
const { getSrc } = useImageSources();
const { width: btnW, height: btnH } = useElementSize(tpl_btn);
const { width: contextMenuW } = useElementSize(tpl_contextMenu);

function handleContextMenu(event, x, y) {
  contextMenuData.value = {
    x,
    y,
  };
}

function handleClick(event) {
  if (!logged.value && props.private) {
    event.preventDefault();
    event.stopPropagation();

    showModal.value = true;
  }
}

const { getLink } = useDownloadables();

watch(copied, (newVal, oldVal) => {
  if (newVal === false) contextMenuData.value = null;
});

onClickOutside(tpl_contextMenu, (event) => {
  contextMenuData.value = null;
});

if (props.useReveal) {
  onMounted(() => {
    requestAnimationFrame(() => {
      reveal(tpl_inner.value, tpl_inner.value, "bottom", {
        fade: true,
        intensity: "strong",
        duration: "long",
      });
    });
  });
}

return { __sfc: true,props, route, contextMenuData, source, text, copy, copied, isSupported, reveal, tpl_inner, tpl_btn, tpl_contextMenu, showModal, card_collections, logged, getSrc, btnW, btnH, contextMenuW, handleContextMenu, handleClick, getLink }
}

}